import React from 'react';
import { translations } from '../data/translations';
import { motion } from 'framer-motion';

export const AboutSection = ({ lang }) => {
  const t = translations[lang].about;

  return (
    <section id="about" className="py-20 bg-zinc-950 text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5" 
           style={{ backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)', backgroundSize: '40px 40px' }}>
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <motion.div 
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="space-y-6"
          >
            <div className="flex items-center gap-4">
              <div className="h-1 w-12 bg-red-600"></div>
              <span className="text-red-500 font-bold uppercase tracking-widest text-sm">Since 2024</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold">{t.title}</h2>
            <p className="text-gray-400 text-lg leading-relaxed">
              {t.content}
            </p>
            <div className="grid grid-cols-2 gap-8 pt-6">
              <div className="text-center p-6 border border-zinc-800 rounded-lg hover:border-red-600/50 transition-colors bg-zinc-900/50">
                <span className="block text-4xl font-bold text-red-500 mb-2">50+</span>
                <span className="text-sm text-gray-400 uppercase tracking-wide">Dishes</span>
              </div>
              <div className="text-center p-6 border border-zinc-800 rounded-lg hover:border-red-600/50 transition-colors bg-zinc-900/50">
                <span className="block text-4xl font-bold text-red-500 mb-2">100%</span>
                <span className="text-sm text-gray-400 uppercase tracking-wide">High Quality Meat</span>
              </div>
            </div>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="relative"
          >
            <div className="relative aspect-square md:aspect-[4/5] rounded-lg overflow-hidden border-2 border-zinc-800 shadow-2xl">
              <img 
                src="https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwyfHxyZXN0YXVyYW50JTIwaW50ZXJpb3J8ZW58MHx8fHwxNzcwMTM5NjczfDA&ixlib=rb-4.1.0&q=85" 
                alt="Restaurant Interior" 
                className="object-cover w-full h-full hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent"></div>
              <div className="absolute bottom-6 left-6 right-6">
                 <p className="text-white font-serif italic text-xl">"Best Grill in Town"</p>
              </div>
            </div>
            {/* Decorative Element */}
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-red-600 z-[-1] rounded-full blur-3xl opacity-20"></div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
